import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs
} from '@bepatient/core';
import { BridgeWebviewComponent } from './bridge-webview/bridge-webview.component';
import { WebviewModalComponent } from './webview-modal/webview-modal.component';
import { SafeUrlPipe } from './safe-url.pipe';

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.BRIDGE_WEBVIEW,
  i18nLabel: 'MODULES.BRIDGE_WEBVIEW',
  icon: 'globe',
  leftMenuAvailableForPages: [],
  routes: [
    {
      path: 'bridge-webview',
      component: BridgeWebviewComponent
    }
  ]
};

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(pageModule.routes),
    IonicModule
  ],
  declarations: [BridgeWebviewComponent, WebviewModalComponent, SafeUrlPipe],
  providers: [
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    {
      provide: CORE_I18N_FOLDER,
      useValue: './bridge/webview/i18n/',
      multi: true
    }
  ]
})
export class BridgeWebviewModule {}
